module.exports = __webpack_public_path__ + "media/application/images/svgs/frown-c8feae12cbeee592186b36e664b56a30.svg";